
import React, { useEffect, useState, useCallback, useMemo, useRef, useImperativeHandle, useReducer } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'
import { Form, useFormikContext } from 'formik'
import { IxField, IxEmptyField } from 'components/forms/field'

import { IxFloatingButtons } from 'components/floating-buttons'
import { useIxOnScreen } from 'hooks/use-on-screen'

import { BaseIcons } from 'enums/base-icons'

import _ from 'lodash'
import { prepareNotification } from 'helpers/prepare-notifications'

import { Button } from 'devextreme-react/button'
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box'
import LoadPanel from 'devextreme-react/load-panel'
import MultiView, { Item as MVItem } from 'devextreme-react/multi-view'

import { useTranslation } from 'react-i18next'

import { RootState } from 'slices'
import { rightsSelector } from 'slices/rights'
import { setNotificationsByKeyThunk, removeNotificationsByKeyThunk } from 'slices/notifications'
import { setActions } from 'slices/action-panel'
import { setFormModes, selectionBannerChanged, selectionChanged, setSelection, setSelectedItem, updateReloadedItem, setDirty, switchTab, closePopup, closeDynamicPopup, selectionBannerLookupDataChanged } from 'slices/pages-slice'  // eslint-disable-line
import { showCPopup } from 'slices/confirmation-popup-slice'
import { useSetFieldValueFromLookup } from 'hooks/lookup-field-hooks/use-set-field-value-from-lookup'
import { settingsMenuSelector } from 'slices/ui'
import { useUserSettingsUpdate } from 'hooks'
import { SettingType } from 'helpers/setting-type-enum'
import { Settings } from 'helpers/settings-enum'

import { useIxJsonSchema } from 'hooks/use-json-schema'

import { keyboardControl } from 'helpers'
import { useIxFocusElement } from 'hooks'

import { IxModuleRights } from 'enums/rights-enum'

import { FormMode } from 'helpers/form-mode-enum'
import { shallowEqual } from 'helpers/shallow-equal'
import { useIxFetchActionsMenu } from 'hooks/use-fetch-actions-menu'

import { BaseForm, Spinner, ValidationSummary, FormGroup  } from 'components'

import { useIxLookupContext } from 'contexts/lookup-context'

import {
    TextInput,
} from 'components/forms'




import { setMaxLabelWidth } from 'helpers/set-max-label-width'

const _pageType = 'subpage'
const _obj = {}

// constants used when no page name is provided
const _belegAusgabe = {}
const _formMode = FormMode.Create
const _tabProps = { initialvalues: {} }


const _expandedFormGroupsKey = 'IxBelegAusgabeForm'

// this is used for i18next-scanner to pick up labels
const _t = (s: string) => s
export const labelsMap: {[k: string]: string} = {
    'BelegeDrucken': _t(''),
    'BelegeSpeichern': _t(''),
    'BelegDir': _t(''),
    'BelegeDirOeffnen': _t(''),
    'BelegeDirLeeren': _t(''),
    'OriginalDateinamen': _t(''),
    'AllesAlsPdf': _t(''),
    'AlsPdfZusammenfassen': _t(''),
    'MitStempeln ': _t(''),
    'ZusammenPdfOeffnen': _t(''),
    'Zippen': _t(''),
}


export const _initialValues: any = {
    "HDR_ID": 0,
    "BelegeDrucken": null,
    "BelegeSpeichern": null,
    "BelegDir": null,
    "BelegeDirOeffnen": null,
    "BelegeDirLeeren": null,
    "OriginalDateinamen": null,
    "AllesAlsPdf": null,
    "AlsPdfZusammenfassen": null,
    "MitStempeln ": null,
    "ZusammenPdfOeffnen": null,
    "Zippen": null
}

const genInitialValues = (val: any = {}) => {
    let initialValues = {
        ..._initialValues,
    }

    initialValues = val ? { ...initialValues, ...val } : initialValues


    return initialValues
}


const visInitialState = {
    0: {},
    1: {},
}

const visReducer = (state: any, action: any) => {
    switch(action.type) {
        case 'show':
            return { ...state, [action.groupId]: { ...state[action.groupId], [action.fieldName]: true } }
        case 'hide':
            return { ...state, [action.groupId]: { ...state[action.groupId], [action.fieldName]: false } }
    }
}

const isGroupVisible = (fieldsVis: any[], index: number) => {
    return (Object.keys(fieldsVis[index]).length === 0) || (Object.values(fieldsVis[index]).indexOf(true) >= 0)
}

const lookupFields: string[] = [
]

export const FocusHandler = ({ itemsData, lastFocusedElement }: any) => {
    const { values } = useFormikContext<typeof _initialValues>()

    useIxFocusElement(values, itemsData, lastFocusedElement, document.getElementById('belegAusgabe-form'))

    return null
}

interface IAutoUpdateForm {
    parentPageName: string,
    pageName: string,
    formMode: FormMode,
    active: boolean,
    resetMode?: () => void
    setInitialValues: (values: any) => void,
    valuesToSet?: any
}

// exported for testing
export const AutoUpdateForm = ({ parentPageName, pageName, formMode, active=true, resetMode, setInitialValues, valuesToSet = null }: IAutoUpdateForm) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { validateForm, values, setValues, errors, touched, dirty, resetForm, setFieldValue, initialValues} = useFormikContext<typeof _initialValues>()
    const { getFieldValue } = useIxLookupContext()  // eslint-disable-line @typescript-eslint/no-unused-vars
    const _prevValues = useRef<any>(values)
    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation()

    const waitingForFormReset = useRef(false)
    const setInitialFieldValue = useCallback((name: string, value: any) => {
        waitingForFormReset.current = true
        setInitialValues((state: any) => {
            const nextState = _.cloneDeep(state)
            _.set(nextState, name, value)
            console.log(`setInitialFieldValue: ${name} = ${value}`, nextState);
            return nextState
        })
    }, [setInitialValues])

    useEffect(() => { waitingForFormReset.current = false }, [initialValues])

    const [setFieldValueFromLookup, setInitialFieldValueFromLookup] = useSetFieldValueFromLookup(setInitialFieldValue)

    const pageType = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].type : _pageType)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const parentModel = useSelector((state: RootState) => parentPageName ? state.pagesSlice[parentPageName].selectedItem : _obj)


    const selectedItem = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].selectedItem : _belegAusgabe)

    const touchedRef = useRef<any>({})
    useEffect(() => {
        touchedRef.current = { ...touched }
    }, [touched])

    const wasChangedRef = useRef<any>({})
    useEffect(() => {
        // reset on initialValues change
        wasChangedRef.current = {}
    }, [formMode, initialValues])
    useEffect(() => {
        for (const key of Object.keys(values)) {
            if (!wasChangedRef.current[key] && !_.isEqual(initialValues[key], values[key])) {
                wasChangedRef.current[key] = true
            }
        }
    }, [initialValues, values])

    // handle valuesToSet
    const appliedValuesToSet = useRef<any>(null)
    const appliedOnInitialValues = useRef<any>(null)
    useEffect(() => {
        // skip if nothing to set or already applied
        if (waitingForFormReset.current || !valuesToSet || !Object.keys(valuesToSet).length || (valuesToSet === appliedValuesToSet.current && initialValues === appliedOnInitialValues.current)) { return }

        appliedValuesToSet.current = valuesToSet
        appliedOnInitialValues.current = initialValues
        setValues((currentValues: any) => {
            let newValues = { ...currentValues, ...appliedValuesToSet.current }
            console.log('IxBelegAusgabeFormContent: setting values from valuesToSet', appliedValuesToSet, 'currentValues', currentValues, 'newValues', newValues)
            return newValues
        })
    }, [valuesToSet, initialValues, setValues])
    
    // this calls the validation with some minimal delay so we can change
    // multiple fields ahd still have single validation ran with the latest
    // values only
    // !! changes with `setFieldValue` should not trigger validation so we
    // don't have multiple validation runs on the same values
    useEffect(() => {
        const timerId = setTimeout(() => {
            validateForm()
        }, 200)

        return () => clearTimeout(timerId)
    }, [values, validateForm])


    // update notifications bubble on error or language change
    // touched and errors are cast to any because they raise some funny error
    // about using string as key
    useEffect(() => {
        if (touched && errors && pageName) {
            const touchedFields = Object.keys(errors).filter(k => (touched as any)[k])
            const messages = touchedFields.map((k: string) => {
                if (labelsMap[k]) {
                    return `${t(labelsMap[k])}: ${t((errors as any)[k].key, (errors as any)[k].options)}`
                } else {
                    return `${k}: ${t((errors as any)[k].key, (errors as any)[k].options)}`
                }
            })
            let notifications = messages.map((err: string, i: number) => ({ type: 'error', msg: err, name: touchedFields[i] }))
            if ((errors as any).globalErrors) {
                const { error, warning, info } = (errors as any).globalErrors
                error && (notifications = notifications.concat(error.map(prepareNotification('error', labelsMap, t))))
                warning && (notifications = notifications.concat(warning.map(prepareNotification('warning', labelsMap, t))))
                info && (notifications = notifications.concat(info.map(prepareNotification('info', labelsMap, t))))
            }
            dispatch(setNotificationsByKeyThunk(notifications, 'belegAusgabe-form'))
        }
    }, [errors, touched, dispatch, i18n.language, t, pageName])


    useEffect(() => {
        // when component is destoyed remove any notifications set in the above useEffect
        return () => dispatch(removeNotificationsByKeyThunk('belegAusgabe-form'))
    }, [dispatch])

    useEffect(() => {
        if (pageName) {
            dispatch(setDirty({ name: pageName, formName: 'IxBelegAusgabeForm', dirty }))
        }
    }, [dirty, dispatch, pageName])

    useEffect(() => {
        if (active && ((formMode === FormMode.Reset && pageName) || (formMode === FormMode.Create && !pageName))) {
            resetForm()
            resetMode && resetMode()
        }
    }, [formMode, resetForm, active, resetMode, pageName])

    useEffect(() => {
        if (formMode === FormMode.Edit && values.HDR_ID !== selectedItem?.HDR_ID) { return }
        pageType === 'page' && dispatch(selectionBannerChanged({ name: pageName, banner: values }))
    }, [values, dispatch, pageName, pageType, formMode, selectedItem?.HDR_ID])

    const prevLookupData = useRef<any>(null)
    useEffect(() => {
        if (pageType !== 'page') { return }

        // formik values are not set yet so we don't want to delete selection banner data
        if (formMode === FormMode.Edit && values.HDR_ID !== selectedItem?.HDR_ID) { return }

        const lookupData = lookupFields.reduce((acc: any, fieldName: string) => {
            const v = getFieldValue(fieldName, false)
            const vFull = getFieldValue(fieldName)
            if ((values[fieldName] && values[fieldName] === v && typeof(vFull) === 'object') || (!values[fieldName] && !v)) {
                acc[fieldName] = vFull
            }
            return acc
        }, ({} as any))

        if (!_.isEqual(prevLookupData.current, lookupData)) {
            prevLookupData.current = lookupData
            dispatch(selectionBannerLookupDataChanged({ name: pageName, bannerLookupData: lookupData }))
        }
    }, [dispatch, pageName, pageType, getFieldValue, values, formMode, selectedItem?.HDR_ID])

    const firstRender = useRef(true)
    const initialValuesSet = useRef<any>({})
    useEffect(() => { firstRender.current = true; initialValuesSet.current = {} }, [initialValues, formMode])  // reset firstRender ref on every initial values change



    useEffect(() => { firstRender.current = false })  // reset firstrRender ref afther thunks are called

    useEffect(() => {
        const _nextPrevValues = { ..._prevValues.current }
        lookupFields.forEach(f => {
            if (_nextPrevValues[f] !== values[f] && values[f] === getFieldValue(f, false)) {
                _nextPrevValues[f] = values[f]
            }
        })
        _prevValues.current = _nextPrevValues
    }, [values, getFieldValue])

    return null
}

type IIxBelegAusgabeFormContentProps = {
    loadingEnabled: boolean,
    active: boolean,
    parentPageName: string,
    pageName: string,
    formMode: FormMode,
    setError?: Function,
    formType?: 'normal' | 'field' | 'gridForm',
    onReset?: Function,
    showSubForm: Function,
    hideSubForm: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    setActions?: Function,
    portalId?: string,
    moduleRight: IxModuleRights,
    valuesToSet?: any,
}

export const IxBelegAusgabeFormContent = (
    {
        active,
        loadingEnabled,
        parentPageName,
        pageName,
        formMode,
        setError,
        formType='normal',
        onReset,
        showSubForm,
        hideSubForm,
        addCrumb,
        popCrumb,
        portalId,
        moduleRight = IxModuleRights.All,
        setActions: _setActions,
        ...props
    }: IIxBelegAusgabeFormContentProps
) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const formRef = useRef(null)

    const {
        values,  // eslint-disable-line @typescript-eslint/no-unused-vars
        setValues,
        errors,
        touched,
        isSubmitting,
        handleReset,
        dirty,
        handleSubmit,
        initialValues,
        
    } = useFormikContext<any>()

    const { getFieldValue } = useIxLookupContext()  // eslint-disable-line @typescript-eslint/no-unused-vars

    const {value: formFieldType} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.formFieldType))


    const [ fieldsVis, visDispatch ] = useReducer(visReducer, visInitialState)
    const [orderMap, setOrderMap] = useState<any>(Object.keys(fieldsVis).map(Number))
    const {value: expandedFormGroups, id: expandedFormGroupsId} = useSelector((state: RootState) => settingsMenuSelector(state, 'belegAusgabe-form'))
    const [firstRender, setFirstRender] = useState(true)
    const setOrderFormGroupsData = useUserSettingsUpdate()

    const onFieldContentReady = useCallback((groupId: number, fieldName: string) => {
        visDispatch({ type: 'show', groupId, fieldName })
    }, [])
    const onEmptyFieldContentReady = useCallback((groupId: number, fieldName: string) => {
        visDispatch({ type: 'hide', groupId, fieldName })
    }, [])

    const itemsData = useMemo(() => ([
        { name: 'BelegeDrucken', index: 0, type: 'field' },
        { name: 'BelegeSpeichern', index: 0, type: 'field' },
        { name: 'BelegDir', index: 0, type: 'field' },
        { name: 'BelegeDirOeffnen', index: 0, type: 'field' },
        { name: 'BelegeDirLeeren', index: 0, type: 'field' },
        { name: 'OriginalDateinamen', index: 0, type: 'field' },
        { name: 'AllesAlsPdf', index: 0, type: 'field' },
        { name: 'AlsPdfZusammenfassen', index: 0, type: 'field' },
        { name: 'MitStempeln ', index: 0, type: 'field' },
        { name: 'ZusammenPdfOeffnen', index: 0, type: 'field' },
        { name: 'Zippen', index: 0, type: 'field' },

        { name: formMode === FormMode.Edit ? t('global:button.save') : t('global:button.create'), index: 0, type: 'button' },
        { name: t('global:button.cancel'), index: 0, type: 'button' },
    ]), [t, formMode])

    const _firstRender = useRef(true)

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            // focus first editable field
            if (!_firstRender.current) { return }
            _firstRender.current = false

            for(let item in itemsData) {
                const fieldElement = (formRef.current as any)?.querySelectorAll(`[name="${itemsData[item].name}"]`)[itemsData[item].index]

                if (fieldElement && fieldElement.getAttribute('aria-readonly') !== 'true' && fieldElement.getAttribute('aria-disabled') !== 'true') {
                    if (fieldElement.type === 'hidden') {
                        if (fieldElement.parentElement.role === 'checkbox') {fieldElement.parentElement.focus()}
                        else {
                            const radiobtn = fieldElement.parentElement.querySelectorAll('.dx-item.dx-radiobutton')[0]

                            fieldElement.parentElement.querySelectorAll('.dx-item.dx-radiobutton')[0].closest('.dx-field-input.dx-radiogroup').focus()
                            fieldElement.parentElement.querySelector('.dx-item.dx-radiobutton.dx-item-selected').classList.remove('dx-state-focused')
                            radiobtn.classList.add('dx-state-focused')
                            radiobtn.focus()
                        }
                    }
                    else {fieldElement.focus()}

                    break
                }
            }
        }, 100)

        return () => clearTimeout(timeoutId)
    }, [itemsData])

    const lastFocusedElement = useRef<any>(null)
    const onKeyboardControl = useMemo(() => keyboardControl(itemsData, t, formRef, lastFocusedElement), [itemsData, t])

    useEffect(() => {
        if (active) {
            let formElement: HTMLElement = (formRef.current as any).closest('.dx-drawer-content')
            if (!formElement) {  // if the form is in a popup we should attach the keyboard control to the popup
                formElement = (formRef.current as any).closest('.dx-popup-content')
            }

            formElement?.addEventListener('keydown', onKeyboardControl, true)

            return () => {
                formElement?.removeEventListener('keydown', onKeyboardControl, true)
            }
        }
    },[active, onKeyboardControl])

    useEffect(() => {
        if (active) {
            const formElement: any = formRef.current

            if (formFieldType === 'label-inside-max-field-width' || formFieldType === 'label-left-max-field-width') {
                setTimeout(() => {
                    setMaxLabelWidth(formElement)
                }, 500)
            }
            else {
                formElement?.style.removeProperty('--max-labels-width')
            }
        }

    },[active, formFieldType])

    useEffect(() => {
        if (active) {
            const formElement: any = document.getElementById('belegAusgabe-form')

            const setPrevFocusedElement = (e: any) => {
                if (e.target.tagName === 'INPUT' || e.target.tagName === 'I' || e.target.className.includes('dropdowneditor')) {
                    lastFocusedElement.current = e.target
                    formElement?.querySelector('.dx-state-focused.dx-radiobutton')?.classList.remove('dx-state-focused')
                    formElement?.querySelector('.dx-checkbox.dx-state-focused')?.classList.remove('dx-state-focused')
                }
            }
            formElement?.addEventListener('mousedown', setPrevFocusedElement)

            return () => {
                formElement?.removeEventListener('mousedown', setPrevFocusedElement)
            }
        }
        }, [active])



    
    const createBtnRef = useRef(null)
    const createBtnOnScreen = useIxOnScreen(createBtnRef)
    const formOnScreen = useIxOnScreen(formRef)

    const activeLicenses = useSelector((state: RootState) => state.rights.activeLicenses)

    const buttonsConfig = useMemo(() => {
        return []
    }, [])


    useEffect(() => {
        if (active && loadingEnabled) {
            const actions = [
                { id: 1, name: '', widget: 'delimiter', location: 'before' },
                ...buttonsConfig.map((b: any, i: number) => ({
                    id: i + 2,
                    name: b.hint,
                    widget: b.disabled ? 'disabledbtn' : 'button',
                    options: { icon: b.icon, onClick: b.onClick, disabled: b.disabled },
                    location: 'before',
                })),
                { id: buttonsConfig.length + 2, name: '', widget: 'delimiter', location: 'before' },
            ]

            if (formType === 'normal') {
                _setActions && _setActions(actions)
            }
        }
    }, [dispatch, activeLicenses, formType, buttonsConfig, loadingEnabled, active, _setActions, moduleRight, formMode])



    useEffect(() => {
        if (firstRender) {
            setFirstRender(false)

            if (expandedFormGroups && Object.hasOwn(expandedFormGroups, 'orderMap')) {
                setOrderMap(expandedFormGroups.orderMap)
            }
        }

    },[expandedFormGroups, firstRender, dispatch])

    const onMoveDown = useCallback((id: number) => {
        const arr = [...orderMap]
        const index: any = arr.indexOf(id)
        if (index || index === 0) {
            [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]]
            setOrderMap(arr)
            setOrderFormGroupsData('form-layout', 'belegAusgabe-form', {...expandedFormGroups, orderMap: arr}, expandedFormGroupsId, SettingType.GlobalSetting)
        }

    },[orderMap, expandedFormGroups, setOrderFormGroupsData, expandedFormGroupsId])

    const onMoveUp = useCallback((id: number) => {
        const arr = [...orderMap]
        const index: any = arr.indexOf(id)

        if (index) {
            [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]]
            setOrderMap(arr)
            setOrderFormGroupsData('form-layout', 'belegAusgabe-form', {...expandedFormGroups, orderMap: arr}, expandedFormGroupsId, SettingType.GlobalSetting)
        }

    },[orderMap, expandedFormGroups, setOrderFormGroupsData, expandedFormGroupsId])

    if (formMode === FormMode.Reset) {
        return <Spinner />
    }

    return active ? (
        <div ref={formRef}>
            <FocusHandler itemsData={ itemsData } lastFocusedElement={ lastFocusedElement }/>
            <Form id='belegAusgabe-form'>
                <div style={ { display: 'flex', flexDirection: 'column' } }>
                    <FormGroup formId='belegAusgabe-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 0 } name={ t('belegausgabe:formBelegAusgabeGroup.Belegausgabe') } caption={ true } style={ isGroupVisible(fieldsVis, 0) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />
                            <Row />

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='BelegeDrucken'
                                            label={ t(labelsMap['BelegeDrucken']) }
                                            active={ loadingEnabled }
                                            groupId={ 0 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 1 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='BelegeSpeichern'
                                            label={ t(labelsMap['BelegeSpeichern']) }
                                            active={ loadingEnabled }
                                            groupId={ 0 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) }
                                        />
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>
                    <FormGroup formId='belegAusgabe-form' onMoveDown={ onMoveDown } onMoveUp={ onMoveUp } orderMap={ orderMap } id={ 1 } name={ t('belegausgabe:formBelegAusgabeGroup.BelegSaveOptions') } caption={ true } style={ isGroupVisible(fieldsVis, 1) ? {} : { display: 'none' } }>
                        <ResponsiveBox>
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />
                            <Row />

                            <Col />
                            <Col screen='sm md lg'/>
                            <Col screen='md lg'/>
                            <Col screen='md lg'/>

                            <Item>
                                    <Location row={ 0 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 0 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ TextInput }
                                                    name='BelegDir'
                                                    label={ t(labelsMap['BelegDir']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 1 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='BelegDir' groupId={ 1 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 1 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 0 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        { false
                                            ? (
                                                <IxField
                                                    as={ TextInput }
                                                    name='BelegeDirOeffnen'
                                                    label={ t(labelsMap['BelegeDirOeffnen']) }
                                                    active={ loadingEnabled }
                                                    groupId={ 1 }
                                                    onContentReady={ onFieldContentReady }
                                                    readOnly={ Array.from('I').includes(moduleRight) }
                                                />
                                            )
                                            : (
                                                <IxEmptyField name='BelegeDirOeffnen' groupId={ 1 } onContentReady={ onEmptyFieldContentReady }/>
                                            )
                                        }
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 2 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 1 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 2 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='BelegeDirLeeren'
                                            label={ t(labelsMap['BelegeDirLeeren']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 3 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 1 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 3 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='OriginalDateinamen'
                                            label={ t(labelsMap['OriginalDateinamen']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 4 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 2 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 4 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='AllesAlsPdf'
                                            label={ t(labelsMap['AllesAlsPdf']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 5 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 2 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 5 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='AlsPdfZusammenfassen'
                                            label={ t(labelsMap['AlsPdfZusammenfassen']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 6 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 3 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 6 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='MitStempeln '
                                            label={ t(labelsMap['MitStempeln ']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0 && values.AlsPdfZusammenfassen !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 7 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 3 } col={ 1 } colspan={ 1 } screen='sm' />
                                    <Location row={ 7 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='ZusammenPdfOeffnen'
                                            label={ t(labelsMap['ZusammenPdfOeffnen']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0 && values.AlsPdfZusammenfassen !== 0) }
                                        />
                                    </div>
                                </Item>
                            <Item>
                                    <Location row={ 8 } col={ 0 } colspan={ 4 } screen='md lg' />
                                    <Location row={ 4 } col={ 0 } colspan={ 1 } screen='sm' />
                                    <Location row={ 8 } col={ 0 } colspan={ 1 } screen='xs' />

                                    <div className='item-div'>
                                        <IxField
                                            as={ TextInput }
                                            name='Zippen'
                                            label={ t(labelsMap['Zippen']) }
                                            active={ loadingEnabled }
                                            groupId={ 1 }
                                            onContentReady={ onFieldContentReady }
                                            readOnly={ Array.from('I').includes(moduleRight) || !(values.BelegeSpeichern !== 0) }
                                        />
                                    </div>
                                </Item>
                        </ResponsiveBox>
                    </FormGroup>

                    
                    <div style={ {order: orderMap.length } }>
                        <div ref={ createBtnRef } style={{marginTop: '1rem', marginLeft: '0.5rem'}}>
                            { buttonsConfig.map((b: any, i: number) => (
                                <Button
                                    key={ i }
                                    text={ b.hint }
                                    type='default'
                                    style={ { marginRight: i !== buttonsConfig.length -1 ? '0.5rem' : undefined } }
                                    { ...b }
                                />
                            )) }
                        </div>
                        <div className='' style={{marginTop: '1rem', marginLeft: '0.5rem'}}>
                        </div>
                    </div>

                    <div className='rb-container' style={ {order: orderMap.length + 1} }>
                        <div className='rb-item' style={{marginLeft: '0.5rem'}}>
                            <ValidationSummary
                                touched={ touched }
                                errors={ errors }
                                labelsMap={ labelsMap }
                            />
                        </div>
                    </div>
                </div>
            </Form>

            <LoadPanel
                position={ { of: '#content' } }
                visible={isSubmitting}
                shadingColor='rgba(0, 0, 0, 0.4)'
                shading={true}
                showIndicator={true}
                showPane={true}
            />

            <IxFloatingButtons show={ loadingEnabled } visible={ !createBtnOnScreen && formOnScreen } buttonsConfig={ buttonsConfig } />
        </div>
    ) : null
}


type FormContentWrapperProps = {
    id: number,
    pageActive?: boolean,
    pageLoadingEnabled?: boolean,
    parentPageName: string,
    pageName: string,
    setInitialValues: (values: any) => void
    setError?: Function,
    showSubForm: Function,
    hideSubForm: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    setActions?: Function,
    moduleRight: IxModuleRights,
    valuesToSet?: any,
}

const FormContentWrapper = ({
        id,
        pageActive,
        pageLoadingEnabled,
        parentPageName,
        pageName,
        setInitialValues,
        setError,
        showSubForm,
        hideSubForm,
        addCrumb,
        popCrumb,
        setActions,
        moduleRight = IxModuleRights.All,
        valuesToSet = null
}: FormContentWrapperProps) => {
    const dispatch = useAppDispatch()
    const pageActiveTabIndex = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].activeTabIndex : 0)
    const active: boolean = useMemo(() => (pageActive || pageActive === undefined) && pageActiveTabIndex === id, [pageActive, pageActiveTabIndex, id])
    const loadingEnabled: boolean = useMemo(() => (pageLoadingEnabled || pageLoadingEnabled === undefined) && pageActiveTabIndex === id, [pageLoadingEnabled, pageActiveTabIndex, id])
    const formMode = useSelector((state: RootState) => pageName ? (state.pagesSlice[pageName].formMode['IxBelegAusgabeForm'] || FormMode.Create) : _formMode)

    const resetMode = useCallback(() => {
        if (pageName) {
            dispatch(setFormModes({ name: pageName, modes: { IxBelegAusgabeForm: FormMode.Create } }))
        }
    }, [dispatch, pageName])

    return (
        <div>
            <AutoUpdateForm
                parentPageName={ parentPageName }
                pageName={ pageName }
                formMode={ formMode }
                active={ active }
                resetMode={ resetMode }
                setInitialValues={ setInitialValues }
                valuesToSet={ valuesToSet }
            />
            <IxBelegAusgabeFormContent
                active={ active && formMode !== FormMode.Reset }
                loadingEnabled={ loadingEnabled }
                parentPageName={ parentPageName }
                pageName={ pageName }
                formMode={ formMode }


                setError={ setError }

                showSubForm={ showSubForm }
                hideSubForm={ hideSubForm }
                portalId='belegAusgabe-portal'

                addCrumb={ addCrumb }
                popCrumb={ popCrumb }

                setActions={ setActions }

                moduleRight={ moduleRight }
            />
        </div>
    )
}


type IxBelegAusgabeFormProps = {
    id: number,
    parentPageName: string,
    pageName: string,
    pageActive?: boolean,
    pageLoadingEnabled?: boolean,
    setActions: (id: number, actions: any[]) => void,
    setError?: Function,
    onSubmitted?: Function,
    addCrumb?: Function,
    popCrumb?: Function,
    moduleName?: string,
    isNested?: boolean,
    preloadedData?: any,
}

export const IxBelegAusgabeForm = ({
    id,
    parentPageName,
    pageName,
    pageActive,
    pageLoadingEnabled,
    setActions,
    setError,
    onSubmitted,
    addCrumb,
    popCrumb,
    moduleName = '',
    isNested,
    preloadedData,
}: IxBelegAusgabeFormProps) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()  // eslint-disable-line

    const pageActiveTabIndex = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].activeTabIndex : 0)
    const active = useMemo(() => (pageActive || pageActive === undefined) && pageActiveTabIndex === id, [pageActive, pageActiveTabIndex, id])

    // load json schema from backend
    const schema = useIxJsonSchema('belegAusgabe')

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const parentModel = useSelector((state: RootState) => parentPageName ? state.pagesSlice[parentPageName].selectedItem : _obj)
    const belegAusgabe = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].selectedItem : _belegAusgabe)
    const formMode = useSelector((state: RootState) => pageName ? (state.pagesSlice[pageName].formMode['IxBelegAusgabeForm'] || FormMode.Create) : _formMode)
    const { initialValues: additionalValues } = useSelector((state: RootState) => pageName ? state.pagesSlice[pageName].tabProps['IxBelegAusgabeForm'] : _tabProps)
    const [dynamicInitialValues, setDynamicInitialValues] = useState({})


    const { right: moduleRight } = useSelector((state: RootState) => rightsSelector(state, moduleName))


    const [fmvIndex, setFmvIndex] = useState(0)

    const showSubForm = useCallback(() => { setFmvIndex(1) }, [])
    const hideSubForm = useCallback(() => { setFmvIndex(0) }, [])

    const [_valuesToSet, _setValuesToSet] = useState<any>(null)
    const _preloadedData = useRef<any>(preloadedData)
    const appliedPreloadedData = useRef<any>(null)

    const submitting = useRef(false)

    useEffect(() => {
        if (!shallowEqual(_preloadedData.current, preloadedData)) {
            _preloadedData.current = preloadedData
        }
    }, [preloadedData])

    const additionalValuesExt = useMemo(() => {
        let _additionalValuesExt: any = {}

        _additionalValuesExt = { ..._additionalValuesExt, ...additionalValues }

        return _additionalValuesExt
    }, [
        additionalValues,
    ])

    const [initialValues, setInitialValues] = useState(genInitialValues(additionalValuesExt))
    const _setActions = useCallback((actionsIn: any[]) => {
        setActions && setActions(id, actionsIn)
    }, [setActions, id])

    const formik = useMemo(() => ({
        initialValues,
        enableReinitialize: true,
        jsonSchema: schema,
        additionalSchemas: {
            // todo: add schemas for additional tables somehow
        },
        avjOptions: {
            coerceTypes: true,
            $data: true,
        },
    }), [
        initialValues,
        schema,
        isNested,
        pageName,
        parentPageName,
    ])

    useEffect(() => {
        if (submitting.current) { return }
        if (formMode === FormMode.Reset) {
            dispatch(setSelection({ name: pageName, selection: 0 }))
            setDynamicInitialValues(state => _.isEqual(state, {}) ? state : {})
            setInitialValues(genInitialValues(additionalValuesExt));
            return
        }

        if (_preloadedData.current !== undefined && !shallowEqual(_preloadedData.current, appliedPreloadedData.current)) {
            if (_preloadedData.current && _preloadedData.current.HDR_ID) {
                dispatch(setSelection({ name: pageName, selection: 1 }))
                dispatch(setSelectedItem({ name: pageName, selectedItem: _preloadedData.current }))
                dispatch(setFormModes({ name: pageName, modes: { IxBelegAusgabeForm: FormMode.Edit } }))
            }
            else {
                _setValuesToSet({ ..._preloadedData.current })
            }

            appliedPreloadedData.current = _preloadedData.current
            // do not return, default values should be set
        }

        if (formMode === FormMode.Edit) {
            const newInitialValues = { ...genInitialValues({ ...additionalValuesExt, ...dynamicInitialValues }), ...belegAusgabe }

            setInitialValues((initialValues: any) => {
                return !shallowEqual(initialValues, newInitialValues)
                    ? newInitialValues
                    : initialValues
            })
        } else {
            setInitialValues((initialValues: any) => {
                const newInitialValues = genInitialValues({ ...additionalValuesExt, ...dynamicInitialValues })
                return _.isEqual(initialValues, newInitialValues) ? initialValues : newInitialValues
            })
        }
    }, [
        belegAusgabe,
        formMode,
        additionalValuesExt,
        preloadedData,
        dynamicInitialValues,
        pageName,
        dispatch,
        _setValuesToSet,
    ])


    useEffect(() => {
        if (active && addCrumb) {
            addCrumb('BelegAusgabeForm')
            return () => popCrumb && popCrumb()
        }
    }, [active, addCrumb, popCrumb])


    useEffect(() => {
        submitting.current = false
    }, [initialValues])

    const showSpinner = useMemo(() => {
        return !submitting.current && (
            !schema
        )
    }, [
        schema,
    ])

    // show loading indicator while json schema is fetched
    if (showSpinner) {
        return (<Spinner />)
    }

    return (
        <div style={ { contentVisibility: active ? 'visible' : 'hidden' } }>
            <MultiView
                selectedIndex={ fmvIndex }
                deferRendering={ false }
            >
                <MVItem>
                    <BaseForm {...formik}>
                        <>
                    {
                        active ? (
                            <FormContentWrapper
                                id={ id }
                                pageActive={ pageActive }
                                pageLoadingEnabled={ pageLoadingEnabled }
                                parentPageName={ parentPageName }
                                pageName={ pageName }


                                setInitialValues={ setDynamicInitialValues }

                                setError={ setError }

                                showSubForm={ showSubForm }
                                hideSubForm={ hideSubForm }

                                addCrumb={ addCrumb }
                                popCrumb={ popCrumb }

                                setActions={ _setActions }

                                moduleRight={ moduleRight }
                                valuesToSet={ _valuesToSet }
                            />
                        ) : null
                    }
                        </>
                    </BaseForm>
                </MVItem>

                <MVItem>
                    <div id='belegAusgabe-portal'></div>
                </MVItem>
            </MultiView>
        </div>
    )
}

type IxFormFieldAutoUpdateProps = {
    active: boolean,
    onValueChanged: Function,
    onReset: Function,
}

const IxFormFieldAutoUpdate = React.forwardRef(({
    active,
    onValueChanged,
    // onReset,
}: IxFormFieldAutoUpdateProps, ref) => {
    const {
        values,  // eslint-disable-line @typescript-eslint/no-unused-vars
        dirty,
        setValues,
        // touched,
        // handleSubmit,
        // handleReset,
    } = useFormikContext<any>()

    // const dispatch = useAppDispatch()
    // const { t } = useTranslation()

    const skipValueChange = useRef(false)
    const prevValues = useRef(values)

    useImperativeHandle(ref, () => ({
        setValues: (_values: any) => {
            if (!_.isEqual(_values, values)) {
                skipValueChange.current = true
                setValues(_values, false)
            }
        }
    }), [values, setValues])

    useEffect(() => {
        if (active && !_.isEqual(values, prevValues.current) && dirty && onValueChanged) {
            if (!skipValueChange.current) {
                onValueChanged(values)
            }
            skipValueChange.current = false
        }
        prevValues.current = values
    }, [onValueChanged, values, active, dirty])

    return null
})

type IxBelegAusgabeFormFieldProps = {
    active: boolean,
    loadingEnabled: boolean,
    label: string,
    setError?: Function,
    onSubmit: Function,
    onValueChanged: Function,
    onReset: Function,
    mode: FormMode,
    value: any,
    formType: 'field' | 'gridForm',
    addCrumb?: Function,
    popCrumb?: Function,
}

export const IxBelegAusgabeFormField = React.forwardRef((
    {
        active,
        loadingEnabled,
        label,
        setError,
        onSubmit,
        onValueChanged,
        onReset,
        mode,
        value,
        formType,
        addCrumb,
        popCrumb
    }: IxBelegAusgabeFormFieldProps,
    ref
) => {
    const fieldAutoUpdateRef = useRef<any>(null)
    const schema = useIxJsonSchema('belegAusgabe')

    const [fmvIndex, setFmvIndex] = useState(0)

    const showSubForm = useCallback(() => {
        setFmvIndex(1)
    }, [])

    const hideSubForm = useCallback(() => {
        setFmvIndex(0)
    }, [])



    const [initialValues, setInitialValues] = useState(_initialValues)

    useEffect(() => {
        setInitialValues({ ..._initialValues, ...value })
    }, [value])

    const formik = useMemo(() => ({
        initialValues: initialValues,
        enableReinitialize: true,
        jsonSchema: schema,
        avjOptions: {
            coerceTypes: true,
            $data: true,
        },
        onSubmit: async (values: any, { setSubmitting }: any) => {
            setSubmitting(true)

            const belegAusgabe = { ...values }

            onSubmit(belegAusgabe)
            setSubmitting(false)
        }
    }), [schema, onSubmit, initialValues])

    useImperativeHandle(ref, () => ({
        setValues: (values: any) => {
            fieldAutoUpdateRef.current?.setValues(values)
        }
    }), [])

    useEffect(() => {
        if (active) {
            addCrumb && addCrumb(label)
            return () => popCrumb && popCrumb()
        }
    }, [active, label, addCrumb, popCrumb])

    // show loading indicator while json schema is fetched
    if (!schema) {
        return (<Spinner />)
    }

    return (
        <MultiView
            selectedIndex={ fmvIndex }
            deferRendering={ false }
            swipeEnabled={ false }
        >
            <MVItem>
                <BaseForm {...formik}>
                    <>
                    <IxFormFieldAutoUpdate
                        ref={ fieldAutoUpdateRef }
                        active={ active }
                        // loadingEnabled={ loadingEnabled && fmvIndex === 0 }
                        onValueChanged={ onValueChanged }
                        onReset={ onReset }
                        // mode={ mode }
                        // formType={ formType }
                    />
                    <AutoUpdateForm
                        parentPageName=''
                        pageName=''
                        formMode={ mode }
                        active={ active }
                        setInitialValues={ setInitialValues }
                    />
                    <IxBelegAusgabeFormContent
                        active={ active }
                        loadingEnabled={ loadingEnabled && fmvIndex === 0 }
                        pageName=''
                        parentPageName=''

                        formMode={ mode }
                        formType={ formType }

                        onReset={ onReset }

                        showSubForm={ showSubForm }
                        hideSubForm={ hideSubForm }

                        addCrumb={ addCrumb }
                        popCrumb={ popCrumb }


                        moduleRight={ IxModuleRights.All }
                    />
                    </>
                </BaseForm>
            </MVItem>
            <MVItem>
                <div id='belegAusgabe-portal'></div>
            </MVItem>
        </MultiView>
    )
})

export default IxBelegAusgabeForm